import { render, staticRenderFns } from "./取込Error.vue?vue&type=template&id=49997f2a&scoped=true&"
import script from "./取込Error.ts?vue&type=script&lang=ts&"
export * from "./取込Error.ts?vue&type=script&lang=ts&"
import style0 from "./取込Error.css?vue&type=style&index=0&id=49997f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49997f2a",
  null
  
)

export default component.exports